export default {
  INIT: 'USER/INIT',
  UPDATE_DATA: 'USER/UPDATE_DATA',
  UPDATE_PARAMS: 'USER/UPDATE_PARAMS',
}
